'use client';

import { useDynamicContext } from '@dynamic-labs/sdk-react-core';
import { ChannelProvider } from 'ably/react';

interface AblyWrapperProps {
  children: React.ReactNode;
}

/**
 * AblyWrapper component that provides an Ably channel context to its children.
 * @component
 * @param {AblyWrapperProps} props - The properties for the component.
 * @param {React.ReactNode} props.children - The child components to be wrapped by the Ably channel context.
 * @returns {JSX.Element} The AblyWrapper component.
 */
export const AblyWrapper: React.FC<AblyWrapperProps> = ({
  children,
}: AblyWrapperProps) => {
  const { user } = useDynamicContext();
  const channelName = `user:${user?.userId}`;

  return (
    <ChannelProvider channelName={channelName}>{children}</ChannelProvider>
  );
};
